import React, {useEffect, useState} from "react";
import Toast from "cogo-toast";
import {DefaultLoader} from "../../../components/DefaultLoader";
import {apiGetTariff} from "./Actions";
import TariffTable from "./TariffTable";
import {useSelector} from "react-redux";
import {FiPlus} from "react-icons/fi";
import {TurnstileButton} from "../components/Button";
import PageHeader from "../components/PageHeader";

const Tariff = () => {
    let [data, setData] = useState(null);
    let [loading, setLoading] = useState(false);
    let user = useSelector((state) => state.user)

    useEffect(() => {
        user.activeAreal && getData()
    }, [user.activeAreal]);

    const getData = () => {
        setLoading(true);
        apiGetTariff(user.activeAreal.id, null, (data) => {
            setData(data);
            setLoading(false);
        }, (error) => {
            Toast.error("Při načítání tarifů nastala chyba.");
            setLoading(false);
        })
    }

    return (
        <>
            {user.activeAreal && (
                <>
                    <PageHeader crumbs={[{label: "Tarify"}]}>
                        {user?.user?.rights?.enigooTurniketsEdit && (
                            <TurnstileButton link="/tariff/add" text="PŘIDAT TARIF" icon={<FiPlus size={12}/>}/>
                        )}
                    </PageHeader>
                    {loading
                        ? <DefaultLoader text={"Načítám tarify..."}/>
                        : <TariffTable data={data} setData={setData}/>
                    }
                </>
            )}
        </>
    );
}
export default Tariff;
